import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { RouterProvider } from "react-router-dom";
import "../styles/globals.css";
import { queryClient } from "./lib/query-client";
import { AppProvider } from "./providers/app.provider";
import { ToastProvider } from "./providers/toast.provider";
import { router } from "./routes/router";
import { AndroidDownloadPage } from "./pages/apk-download.page";

export function isAndroid() {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent);
}

const BROWSER_CHOICE_KEY = "continue-in-browser";

export function App() {
  const [skipApkPrompt, setSkipApkPrompt] = useState(
    () => sessionStorage.getItem(BROWSER_CHOICE_KEY) === "1"
  );

  if (isAndroid() && !skipApkPrompt) {
    return (
      <AndroidDownloadPage
        onContinueInBrowser={() => {
          sessionStorage.setItem(BROWSER_CHOICE_KEY, "1");
          setSkipApkPrompt(true);
        }}
      />
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AppProvider>
          <RouterProvider router={router} />
        </AppProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;
